import dayjs from 'dayjs'
import { changeTimeLocalToUtc } from '../../../helper'
import { DATE_FORMAT } from '../../../utils/constants'

export class DealDigitalDoubles {
  constructor(form, currencyNormalize) {
    this.deal_type = form.deal_type.name
    this.client_side = form.client_side
    this.base_currency = form.currency_pair.substring(0, 3)
    this.counter_currency = form.currency_pair.substring(3, 6)
    this.client = form.client
    this.market_maker = form.market_maker
    this.trade_date = changeTimeLocalToUtc(form.trade_date, DATE_FORMAT.REGULAR_DATE_TIME)
    this.quantity = Number(form.quantity)
    this.client_premium_amount = Number(form.client_premium_amount)
    this.market_maker_premium_amount = Number(form.market_maker_premium_amount)
    this.client_premium_currency = form.client_premium_currency.name
    this.market_maker_premium_currency = form.market_maker_premium_currency.name
    this.fixing_source = form.fixing_source
    this.expiry = form.expiry ? dayjs(form.expiry).format(DATE_FORMAT.REGULAR_DATE) : ''
    if (
      currencyNormalize.data &&
      (currencyNormalize?.data[this.base_currency]?.is_ndf ||
        currencyNormalize?.data[this.counter_currency]?.is_ndf)
    ) {
      this.fixing_date = this.expiry
    }
    this.client_premium_date = form.client_premium_date
      ? dayjs(form.client_premium_date).format(DATE_FORMAT.REGULAR_DATE)
      : ''
    this.market_maker_premium_date = form.market_maker_premium_date
      ? dayjs(form.market_maker_premium_date).format(DATE_FORMAT.REGULAR_DATE)
      : ''

    this.put_call = form.put_call
    this.settlement_date = form.settlement_date
      ? dayjs(form.settlement_date).format(DATE_FORMAT.REGULAR_DATE)
      : ''
    this.expiry = form.expiry ? dayjs(form.expiry).format(DATE_FORMAT.REGULAR_DATE) : ''
    this.strike = Number(form.strike)
    this.cut = form.cut
    this.client_trader_name = form.client_trader_name
    this.market_maker_trader_name = form.market_maker_trader_name
    this.payout_amount = Number(form.payout_amount)
    this.payout_currency = form.payout_currency.name
    this.spot_ref = Number(form.spot_ref)
    this.timing = form.timing
    this.lower_barrier = Number(form.lower_barrier)
    this.upper_barrier = Number(form.upper_barrier)
    this.window_start = form.window_start
      ? dayjs(form.window_start).format(DATE_FORMAT.REGULAR_DATE)
      : ''
    this.window_end = form.window_end ? dayjs(form.window_end).format(DATE_FORMAT.REGULAR_DATE) : ''
    this.client_note = form.client_note
    this.market_maker_note = form.market_maker_note
    this.trade_origin = 'FXER'
  }
}
